import * as React from "react";
import { Link } from "react-router-dom";
import { FieldNav } from "../components/FieldNav.js";
import { FieldFooter } from "../components/FieldFooter.js";
import { MailtoContact } from "../components/MailtoContact.js";
import { useDocumentTitle } from "../hooks/useDocumentTitle.js";
import { SEO_TITLES } from "../lib/seo-titles.js";
import "../styles/landing-field.css";
import "../styles/content-pages-field.css";

export function AboutRoute(): React.ReactElement {
  useDocumentTitle(SEO_TITLES["/about"]);
  return (
    <div className="v-field">
      <FieldNav />
      <main id="main" className="v-field-c__page">
        <div className="container">
          <span className="v-field-c__eyebrow">About</span>
          <h1 className="v-field-c__title">
            Every minute is <span className="stripe">real</span> practice.
          </h1>
          <p className="v-field-c__lede">
            Sports Academy Games turns math practice into games kids actually want to play — without
            turning their attention into a product.
          </p>
          <div className="v-field-c__prose">
            <p>
              We're a small US team building short math games around one idea: every minute a
              student plays should be real practice. Behind every game is one shared question bank,
              curated by topic, grade, and drill type — the game is just a fun shell around vetted
              practice.
            </p>
            <p>
              Every game runs walled off from the rest of the site and the other games, so nothing
              that tracks or advertises to people runs inside, and we never sell student data.
            </p>
          </div>
          <div className="v-field-c__actions">
            <Link className="btn-field-primary" to="/games">
              Browse the games
            </Link>
            <MailtoContact className="btn-field-secondary">Email us</MailtoContact>
          </div>
        </div>
      </main>
      <FieldFooter />
    </div>
  );
}
